import type { ComponentType } from "react"
import { withViewData } from "../../../App/ViewData"
import type { AppViewProps } from "../Params"
import { AllShipsDataView } from "./DataView"

export function withAllShipsData(UI: ComponentType<AppViewProps>): ComponentType<AppViewProps> {
  return withViewData<AppViewProps>({
    acquire: AllShipsDataView,
    ui: UI,
  });
}

export { useAllShips } from "./Context"
